<template>
  <div class="main">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"> <router-link to="/">{{ this.$store.state.listcatename }}</router-link></li>
        <li class="breadcrumb-item active" aria-current="page">{{ doc.title }}</li>
      </ol>
    </nav>
    <div class="row">
      <nav class="position-sticky d-none d-md-block bd-toc col-md-auto" style="top: 4rem;"
        aria-label="Secondary navigation" v-if="meta.paragraph">
        <nav>
          <ul>
            <li><span @click="toTop" class="btn-link font-weight-bold">{{ doc.title }}</span></li>
            <li v-for="paragraph in meta.paragraph.paragraphs" :key="paragraph.id">
              <span class="btn-link" @click="toAnchor(paragraph.id)">{{ paragraph.order + '.' + paragraph.title
                }}</span>
              <ul>
                <li v-for="part in paragraph.parts" :key="part.id">
                  <span class="btn-link" @click="toAnchor(part.id)">{{ part.title }}</span>
                </li>
              </ul>
            </li>
          </ul>
        </nav>
      </nav>
      <div class="card col article">
        <div class="card-body">
          <h6 class="card-title fs-5 fw-bold">{{ doc.title }}<br>
            <small class="text-muted fw-lighter">{{ doc.subtitle }}</small>
          </h6>
          <p class="card-subtitle border-bottom pb-2 mb-3 text-muted">
            <small v-html="tags"></small>
            <small class="pull-right">{{ doc.updatedate }} </small>
          </p>
          <p class="font-italic paragraph" v-html="doc.preface"></p>
          <p class="font-weight-normal paragraph" v-html="doc.body"></p>
          <div class="row row-cols-4 px-3">
            <el-image class="col img-fluid px-0" style="margin-right: 2px;margin-bottom: 2px;" :src="image" :key="image"
              :preview-src-list="meta.fileList" v-for="image in meta.fileList" fit="cover"></el-image>
          </div>
          <div v-if="meta.paragraph">
            <div v-for="paragraph in meta.paragraph.paragraphs" :key="paragraph.id">
              <h5 :id="paragraph.id" class="font-weight-bold text-primary-emphasis anchor-title"
                v-html="paragraph.order + '.' + paragraph.title"></h5>
              <div class="row row-cols-4 px-4">
                <el-image class="col img-fluid px-0" style="margin-right: 2px;margin-bottom: 2px;" :src="image"
                  :key="image" :preview-src-list="paragraph.fileList" v-for="image in paragraph.fileList"
                  fit="cover"></el-image>
              </div>
              <p class="card-text font-weight-normal paragraph text-dark" v-html="paragraph.body"></p>
              <div class="ps-3" v-for="part in paragraph.parts" :key="part.id">
                <h6 :id="part.id" class="card-text font-weight-bold part text-primary-emphasis anchor-title"
                  v-if="part.title" v-html="part.title">
                </h6>
                <div class="row row-cols-4 px-4">
                  <el-image class="col img-fluid px-0" style="margin-right: 2px;margin-bottom: 2px;" :src="image"
                    :key="image" :preview-src-list="part.fileList" v-for="image in part.fileList"
                    fit="cover"></el-image>
                </div>
                <p class="card-text text-dark-emphasis part" v-html="part.body"></p>
                <pre v-if="part.type === 'code' && part.code"><code><p v-html="part.code"></p></code></pre>
              </div>
            </div>
          </div>
          <p class="card-text paragraph" v-if="doc.summary"><mark v-html="doc.summary"></mark></p>
        </div>
        <button type="button" class="btn btn-link text-right" @click="switchRuby">{{ rubybtn }}</button>
      </div>
      <div class="fixed-bottom d-md-none text-bg-light p-3">
        <span @click="drawer = true" class="btn-link font-weight-bold">
          {{ doc.title }}
        </span>
      </div>
      <el-drawer :title="doc.title" :visible.sync="drawer" :direction="direction" size="50%" :with-header="true">
        <ul v-if="meta.paragraph">
          <li><span @click="toTop" class="btn-link font-weight-bold">{{ doc.title }}</span></li>
          <li v-for="paragraph in meta.paragraph.paragraphs" :key="paragraph.id">
            <span class="btn-link" @click="toAnchor(paragraph.id)">{{ paragraph.order + '.' + paragraph.title }}</span>
            <ul>
              <li v-for="part in paragraph.parts" :key="part.id">
                <span class="btn-link" @click="toAnchor(part.id)">{{ part.title }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import sx from "../utils/core.js";
// Import jquery
import $ from 'jquery'
// Make it available globally as it needs to be accessible within the single file components (.vue)
window.$ = $

export default {
  data() {
    return {
      category: '',
      tags: '',
      doc: {},
      gallery: [],
      meta: {},
      drawer: false,
      direction: 'btt',
      rubybtn: '开启注音'
    };
  },
  mounted() {
    const that = this;
    that.init();
    setTimeout(function () {
      that.initRuby()
    }, 1000);
  },
  methods: {
    switchRuby() {
      const that = this
      const showRuby = JSON.parse(localStorage.getItem('showRuby'))
      if (showRuby) {
        localStorage.setItem('showRuby', false)
      } else {
        localStorage.setItem('showRuby', true)
      }
      that.initRuby()
    },
    initRuby() {
      const that = this
      const showRuby = JSON.parse(localStorage.getItem('showRuby'))
      if (showRuby) {
        that.rubybtn = '关闭注音'
        $('ruby rt').removeClass("d-none")
      } else {
        that.rubybtn = '开启注音'
        $('ruby rt').addClass("d-none")
      }
    },
    toTop() {
      document.documentElement.scrollTop = 0;
    },
    toAnchor(id) {
      const loc = document.getElementById(id);
      if (loc) {
        loc.scrollIntoView({ behavior: 'smooth' });
      }
    },
    init() {
      const that = this;

      const mymodal = sx.showWaiting()
      var params = {
        id: that.$route.params.docid,
        token: localStorage.getItem("token") || "token"
      }
      var url = that.$store.state.baseurl + '/app/cmshelper/fetchDocument'
      that.category = ''
      that.tags = ''
      that.doc = {}
      that.gallery = []
      that.meta = {}
      sx.request(
        url,
        params,
        function (result) {
          if (result.status === 'ok') {
            that.items = result.data.rows
            if (that.items.length > 0) {
              that.doc = that.items[0]
              if (that.doc.updatedate) {
                that.doc.updatedate = that.doc.updatedate.substring(0, 10)
                document.title = that.doc.title + '_' + that.doc.subtitle
              }
              that.meta = JSON.parse(that.items[0].meta || "{}")
              if (that.meta.paragraph) {
                $.each(that.meta.paragraph.paragraphs, function (index, paragraph) {
                  $.each(paragraph.parts, function (idx, part) {
                    part.body = sx.formatrt(part.body)
                    part.code = sx.formatrt(part.code)
                    if (part.style && part.style.reservedWords) {
                      part.body = sx.formatem(part.body, part.style.reservedWords)
                      part.code = sx.formatem(part.code, part.style.reservedWords)
                    }
                  });
                });
              }
              // that.category = sx.getoptname(that.doc.category, that.$store.state.categorylist)
              that.tags = sx.gethtmltags(that.doc.tags)
              $.each(that.meta.gallery, function (idx, url) {
                var baseurl = 'https://cloud.salesmini.cn'
                that.gallery.push({
                  url: baseurl + url
                })
              });
            }
            $('ruby rt').addClass("d-none")
            sx.hideWaiting(mymodal)
          } else {
            sx.toastSuccess(result.message)
            console.log(result.message)
            sx.hideWaiting(mymodal)
          }
        },
        function () {
          console.log('error')
        }
      )
      sx.hideWaiting(mymodal)
    }
  }
}
</script>
<style>
.article {
  margin-top: 0.5rem;
}

.paragraph {
  white-space: pre-wrap;
  margin-bottom: 8px;
}

.part {
  white-space: pre-wrap;
  margin-bottom: 8px;
}

.anchor-title {
  padding-top: 65px;
}

.img-thumbnail {
  max-height: 300px
}

.btn-link {
  cursor: pointer;
  color: #77757a
}

mark {
  margin-right: 8px
}

pre {
  background-color: #e9ecef;
  border-radius: 6px;
  padding: 8px;
}

ruby {
  text-indent: 0
}

rt {
  margin-bottom: -3px;
  font-size: .625rem;
  color: #8a2be2;
  font-weight: 400
}

em {
  margin: 0 4px 0 2px;
  color: red;
  background-color: #faebd7
}

.bd-toc {
  position: sticky;
  top: 4.2rem;
  overflow-y: auto;
  height: calc(80vh - 4.2rem);
}

li {
  list-style-type: none;
}

ul {
  padding-inline-start: 20px
}

.bd-toc nav li a {
  color: #77757a;
}

.font-weight-bold {
  font-weight: bold
}
</style>
